import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: documentLinksEvent.
 * @param {object} DocumentLinkEventParams Object with the documentLink event details.
 * @param {string} DocumentLinksEventParams.documentName name of the document
 * @param {string} [DocumentLinksEventParams.documentUrl] link to the document
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { documentLinkEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * documentLinkEvent({
 *    documentName: "totalcheckingguide",
 *    documentUrl: "https://www.chase.com/downloadThisDocument.pdf"
 * });
 *
 * // With additional payload data
 * documentLinkEvent(
 *   {
 *    documentName: "totalcheckingguide"
 *    documentUrl: "https://www.chase.com/downloadThisDocument.pdf"
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function documentLinkEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.DOCUMENT_LINK, params, customPayload);
}
